<template>
  <div v-if="node.type">
    <component
      :is="componentName"
      :nid="parseInt(node.nid)"
    />
  </div>
</template>

<style>
</style>

<script>
import {asyncLoader, pageMixin} from '../generic-node-common'

export default {
  name: 'generic-node',
  headData: true,
  headTitle() {
    return this.node.title
  },
  mixins: [
    pageMixin
  ],
  asyncData: (args) => asyncLoader(args)
}
</script>
